import React from "react";
import {Navigate} from "react-router-dom";
import Logout from "../admin/components/Authentication/Logout";
import Login from "../admin/components/Authentication/Login";
import ForgetPasswordPage from "../admin/components/Authentication/ForgetPassword";
import Register from "../admin/components/Authentication/Register";
import Plan from "../admin/components/transaction/Plan";
import HospitalUser from "../admin/components/hospital/HospitalUser";
import Contact from "../admin/components/contact/Contact";
import AccreditationUsers from "../admin/components/accreditation/AccreditationUsers";
import AccreditationCompany from "../admin/components/accreditation/AccreditationCompanyPage";
import Managers from "../admin/components/Managers/Managers";
import Extract from "../admin/components/Extract/Extract";
import Import from "../admin/components/import/Import";
import Department from "../admin/components/Department/Department";
import OfficerPage from "../admin/components/Officer/OfficerPage";
import Scale from "../admin/components/scale";
import Duty from "../admin/components/duty";
import SearchDutyMap from "../admin/components/searchDutyMap";
import SearchDuty from "../admin/components/searchDuty";
import MyDuty from "../admin/components/duty/MyDuty";
import ApproveDutyExchange from "../admin/components/duty/ApproveDutyExchange";
import NotificationsPage from "../admin/components/notification/NotificationsPage";
import ReviewsMy from "../admin/components/reviewsMy";
import ReviewsRealize from "../admin/components/reviewsRealize";
import Checkout from "../admin/components/checkout";
import Profile from "../admin/components/profile/Profile";
import Error from "../admin/components/error404";
import Unauthorized from "../admin/components/unauthorized";
import ErrorPage from "../admin/components/error500";
import Dashboard from "../admin/components/dashboard";
import LagoutClient from "../admin/components/Authentication/lagoutClient";
import ScaleDashboardPage from "../admin/components/scale/ScaleDashboardPage";
import ScaleRegisterPage from "../admin/components/scale/ScaleRegisterPage";
import ScaleConfigPage from "../admin/components/scale/ScaleConfigPage";

import ScalePostingPage from "../admin/components/scale/ScalePostingPage";
import DutyApproveManagers from "../admin/components/duty/DutyApproveManagers";
import HospitalDetail from "../admin/components/detail-hospital";
import ManagersAvaliableUserPage from "../admin/components/accreditation/ManagersAvaliableUserPage";
import UserGuide from "../admin/components/userGuide/ListView";
import UserGuideOverview from "../admin/components/userGuide/Overview";
import DutyCalendarPage from "../admin/components/duty/DutyCalendarPage";
import Integrations from "../admin/components/integrations/Integrations";
import ExtractManagers from "../admin/components/ExtractManagers/ExtractManagers";
import SpecialtiesPage from "../admin/components/Specialties/SpecialtiesPage";
import PreferencesPage from "../admin/components/Preferences/PreferencesPage";
import ChangePassword from "../admin/components/Authentication/ChangePassword";
import ConfirmEmail from "../admin/components/Authentication/ConfirmEmail";
import Unsubscribe from "../admin/components/Authentication/Unsubscribe";
import IntegrationCallback from "../admin/components/integrations/IntegrationsCallback";
import Lead from "../admin/components/Lead/Lead";
import PresenceCheckPage from "../admin/components/duty/PresenceCheckPage";
import DutyControl from "../admin/components/duty/DutyControl";
import DutyRankingPage from "../admin/components/duty/DutyRankingPage";
import WhiteLabel from "../admin/components/WhiteLabel";

// Video Module
import VideoCallsPage from "../admin/components/Video/VideoCallsPage";
import VideoCallPublic from "../admin/components/Video/VideoCallPublic";
import VideoQueuePage from "../admin/components/Video/VideoQueuePage";
import VideoHistoryPage from "../admin/components/Video/VideoHistoryPage";
import VideoClientsPage from "../admin/components/Video/VideoClientsPage";
import VideoDepartmentsPage from "../admin/components/Video/VideoDepartmentsPage";
import VideoAttendeesPage from "../admin/components/Video/VideoAttendeesPage";
import VideoStatsPage from "../admin/components/Video/VideoStatsPage";
import VideoRoom from "../admin/components/Video/VideoRoom";


//Dashboard


const authProtectedRoutes = [

    {path: "/admin", component: <Dashboard/>},
    {path: "/admin/plan", allowedTypes: [1, 7], component: <Plan/>},
    {path: "/admin/location", component: <HospitalUser/>, allowedTypes: [1, 2, 3, 7]},

    {path: "/admin/help-desk", component: <Contact/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/user-guide", component: <UserGuide/>},
    {path: "/admin/user-guide-description/:url", component: <UserGuideOverview/>},


    {path: "/admin/accreditation-users", component: <AccreditationUsers/>, allowedTypes: [1, 7]},
    {path: "/admin/accreditation-company", component: <AccreditationCompany/>, allowedTypes: [2, 3, 7]},
    {path: "/admin/managers-user-available", component: <ManagersAvaliableUserPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/managers", component: <Managers/>, allowedTypes: [2, 3, 7]},
    {path: "/admin/extract", component: <Extract/>, allowedTypes: [1, 7]},
    {path: "/admin/lead", component: <Lead/>, allowedTypes: [7]},
    {path: "/admin/extract-managers", component: <ExtractManagers/>, allowedTypes: [1, 2, 3, 7, 8]},
    {path: "/admin/import", component: <Import/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/department", component: <Department/>, allowedTypes: [2, 3, 7]},
    {path: "/admin/officer", component: <OfficerPage/>, allowedTypes: [2, 3, 7]},
    {path: "/admin/specialties", component: <SpecialtiesPage/>, allowedTypes: [2, 3, 7]},
    {path: "/admin/preferences", component: <PreferencesPage/>, allowedTypes: [2, 3, 7]},


    {path: "/admin/location-detail/:url", component: <HospitalDetail/>},


    {path: "/admin/scale", component: <Scale/>, allowedTypes: [1, 2, 3, 7]},

    {path: "/admin/scale-dashboard", component: <ScaleDashboardPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/scale-register", component: <ScaleRegisterPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/scale-config", component: <ScaleConfigPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/scale-posting", component: <ScalePostingPage/>, allowedTypes: [1, 2, 3, 7]},


    {path: "/admin/duty-register", component: <Duty/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/presence-check", component: <PresenceCheckPage />, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/duty-calendar", component: <DutyCalendarPage/>, allowedTypes: [1, 2, 3, 7, 8]},
    {path: "/admin/duty-search-map", component: <SearchDutyMap/>, allowedTypes: [1, 7]},
    {path: "/admin/duty-search", component: <SearchDuty/>, allowedTypes: [1, 7]},
    {path: "/admin/duty-my", component: <MyDuty/>, allowedTypes: [1, 7]},
    {path: "/admin/duty-approve-duty-exchange", component: <ApproveDutyExchange/>, allowedTypes: [1, 7]},
    {path: "/admin/duty-approve-managers", component: <DutyApproveManagers/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/duty-control", component: <DutyControl/>, allowedTypes: [1, 7, 8]},
    {path: "/admin/duty-ranking", component: <DutyRankingPage/>, allowedTypes: [1, 2, 3, 7]},

    {path: "/admin/notification-list", component: <NotificationsPage/>},
    {path: "/admin/reviews-my", component: <ReviewsMy/>},
    {path: "/admin/reviews-realize", component: <ReviewsRealize/>},

    {path: "/admin/invoice", component: <Checkout/>, allowedTypes: [1, 7]},
    {path: "/admin/profile", component: <Profile/>},
    {path: "/admin/integrations", component: <Integrations/>},
    {path: "/admin/integration/callback/:integration", component: <IntegrationCallback/>},

    // White Label
    {path: "/admin/white-label", component: <WhiteLabel/>, allowedTypes: [8]},

    // Video Module Routes
    {path: "/admin/video/calls", component: <VideoCallsPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/queue", component: <VideoQueuePage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/history", component: <VideoHistoryPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/clients", component: <VideoClientsPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/departments", component: <VideoDepartmentsPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/attendees", component: <VideoAttendeesPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/stats", component: <VideoStatsPage/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/sala/:attendanceId", component: <VideoRoom/>, allowedTypes: [1, 2, 3, 7]},
    {path: "/admin/video/sala/:attendanceId/:callId", component: <VideoRoom/>, allowedTypes: [1, 2, 3, 7]},

    {path: "/admin/404", component: <Error/>},
    {path: "*", component: <Error/>},
    {path: "/admin/unauthorized", component: <Unauthorized/>},
    {path: "/admin/500", component: <ErrorPage/>},

    {path: "/admin/dashboard", component: <Dashboard/>},
    {path: "/dashboard", component: <Dashboard/>},
    {path: "/", component: <Dashboard/>},

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name

    // {
    //     path: "/",
    //     exact: true,
    //     component: <Navigate to="/admin/dashboard"/>,
    // }

];

const publicRoutes = [
    // Authentication Page
    {path: "/admin/logout", component: <LagoutClient/>},
    {path: "/logout", component: <Logout/>},
    {path: "/login", component: <Login/>},
    {path: "/forgot-password", component: <ForgetPasswordPage/>},
    {path: "/register", component: <Register/>},

    {path: "/change-password/:token", component: <ChangePassword/>},
    {path: "/confirm-email/:status", component: <ConfirmEmail/>},
    {path: "/unsubscribe/:status", component: <Unsubscribe/>},

    // Plantões Público
    {path: "/duty-map", component: <SearchDutyMap/>},
    {path: "/duty-list", component: <SearchDuty/>},

    // Video Público
    {path: "/video", component: <VideoCallPublic/>},
    {path: "/video/:token", component: <VideoCallPublic/>},
    {path: "/video/sala/:attendanceId", component: <VideoRoom/>},

];

export {authProtectedRoutes, publicRoutes};